import PropTypes from 'prop-types';
import createChainablePropType from './createChainablePropType';
export const getComponentPropType = component => {
  if ('defaultProps' in component) {
    const {
      propTypes,
      defaultProps
    } = component;
    return createChainablePropType(PropTypes.elementType, 'componentProp', {
      propTypes,
      defaultProps
    });
  }
  const {
    propTypes
  } = component;
  return createChainablePropType(PropTypes.elementType, 'componentProp', {
    propTypes
  });
};

// Using an `any` type here because of how low-level this function is &
// its varied use across product apps
export const isRenderable = children => children != null && children !== false;